import React from 'react';
import { Volume2, Check } from 'lucide-react';

export function VoicePicker({
  voices = [],
  selectedVoiceId,
  onSelectVoice,
  onPreviewVoice,
  playingVoiceId
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <div>
        <span style={{ fontSize: '10px', fontWeight: 700, color: 'var(--primary)', letterSpacing: '0.05em', textTransform: 'uppercase' }}>
          ÂM THANH & PHONG CÁCH
        </span>
        <h4 style={{ fontSize: '14px', fontWeight: 700, color: 'var(--text-main)', marginTop: '1px' }}>
          Giọng đọc AI tiếng Việt
        </h4>
      </div>

      {/* Grid of 6 Voices */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: '6px' }}>
        {voices.map((voice) => {
          const isSelected = selectedVoiceId === voice.id;
          const isPlaying = playingVoiceId === voice.id;

          return (
            <div
              key={voice.id}
              onClick={() => onSelectVoice(voice.id)}
              style={{
                padding: '8px 10px',
                borderRadius: 'var(--radius-sm)',
                background: isSelected ? '#FFF7ED' : '#FFFFFF',
                border: `1.5px solid ${isSelected ? 'var(--primary)' : 'var(--border-color)'}`,
                cursor: 'pointer',
                transition: 'all var(--transition-fast)',
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                position: 'relative'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '12px', fontWeight: 700, color: isSelected ? 'var(--primary)' : 'var(--text-main)' }}>
                  {voice.name}
                </span>

                {isSelected && (
                  <div style={{ width: '14px', height: '14px', borderRadius: '50%', background: 'var(--primary)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Check size={9} color="#FFFFFF" strokeWidth={3} />
                  </div>
                )}
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '10px', color: 'var(--text-muted)' }}>
                  {voice.gender === 'female' ? 'Nữ' : 'Nam'} • {voice.region === 'north' ? 'Bắc' : 'Nam'}
                </span>

                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    onPreviewVoice(voice);
                  }}
                  style={{
                    background: isPlaying ? 'var(--primary)' : 'rgba(0, 0, 0, 0.05)',
                    border: 'none',
                    borderRadius: 'var(--radius-full)',
                    padding: '2px 8px',
                    color: isPlaying ? '#FFFFFF' : 'var(--text-main)',
                    fontSize: '10px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '2px'
                  }}
                >
                  <Volume2 size={10} />
                  <span>{isPlaying ? 'Dừng' : 'Thử'}</span>
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default VoicePicker;
